import { Platform, StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";
import { HEADER_HEIGHT } from "../header/Header.style";

const style = () => {
  const {
    borderRadius4,
    borderWidth1,
    colorBgBase,
    colorBgPrimaryLight,
    space2,
    space4,
    space6,
    space10,
    space12,
    space16,
    space20,
    colorTextMedium,
  } = theme();

  return StyleSheet.create({
    banner: {
      marginBottom: space4,
    },
    benefitsSeparator: {
      borderTopColor: colorBgPrimaryLight,
      borderTopWidth: borderWidth1,
    },
    desktopBackground: {
      backgroundColor: colorBgPrimaryLight,
    },
    desktopLayoutSpacing: {
      paddingVertical: space12,
    },
    desktopListSpacing: {
      paddingRight: space16,
    },
    desktopResume: {
      borderRadius: borderRadius4,
      overflow: "hidden",
      backgroundColor: colorBgBase,
      ...Platform.select({
        web: {
          position: "sticky",
          top: space12,
          alignSelf: "flex-start",
        },
      }),
      // oxlint-disable-next-line typescript/no-explicit-any
    } as any,
    emptyBasketMessage: {
      display: "flex",
      flexGrow: 1,
      justifyContent: "center",
      marginHorizontal: "auto",
    },
    emptyBasketMessageBody: {
      color: colorTextMedium,
      marginVertical: space4,
    },
    emptyBasketMessageButton: {
      alignSelf: "flex-start",
    },
    emptyBasketMessageLarge: {
      paddingVertical: space20,
      width: "auto",
    },
    emptyBasketMessageSmall: {
      padding: space6,
      paddingVertical: space10,
    },
    emptyStateContainer: {
      flexGrow: 1,
    },
    header: {
      height: HEADER_HEIGHT,
    },
    infoboxMobileSpacing: {
      marginHorizontal: space6,
      marginTop: space6,
    },
    mobileBackground: {
      backgroundColor: colorBgBase,
    },
    productListSeparator: {
      marginTop: space6,
    },
    scrollView: {
      flex: 1,
    },
    separator: {
      borderTopColor: colorBgPrimaryLight,
      borderTopWidth: space2,
    },
    spinnerWrapper: {
      alignItems: "center",
      backgroundColor: colorBgBase,
      display: "flex",
      flexGrow: 1,
      justifyContent: "center",
    },
    topSellingWrapper: {
      width: "100%",
    },
  });
};

export { style };
